import pegasus from '../../build/global/js/00-pegasus';
import flatpickr from '../../build/webpack/node_modules/flatpickr';

window.annualLeaveCalc = () => {
    return{
        selectFeilds: null,
        dateFields: null,
        restOfYearEnabled: false,
        init(){
            this.selectFields = this.$el.querySelectorAll('select');
            this.dateFields = this.$el.querySelectorAll('[data-date-picker]');

            this.initSelects();
            this.initDates();
            this.totalWorkingDays();
        },
        initSelects(){
            pegasus.selectField(this.selectFields, {
                openOnHover: false,
                itemsToShow: 5,
                classNames: {
                    outerWrapper:   'mt-4',
                    selector:       'flex justify-between w-full md:w-28 cursor-pointer body-small transition duration-300 border border-greyscale-white-04 text-left py-2.5 px-5 rounded-[50px] focus:outline-none',
                    selectorOpen:   'rounded-b-none rounded-[20px] border-greyscale-white-01 bg-greyscale-white-01',
                    selectionList:  'w-full md:w-28 overflow-hidden bg-greyscale-white-01 border border-greyscale-white-04 border-t-0 rounded-b-[30px] px-3',
                    listItem:       'text-greyscale-white-06 body-small font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-04 transition duration-300 hover:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });
        },
        initDates(){
            const dateFields = flatpickr(this.dateFields, {
                dateFormat: "d/m/Y",
                disableMobile: "true",
                defaultDate: new Date(),
            });
        },
        totalWorkingDays(value){
            let text = '',
                daysWorking = document.getElementById('daysWorking').value,
                daysWorkingWeek = document.getElementById('daysWorkingWeek').value,
                daysFullTimeAllowance = document.getElementById('daysFullTimeAllowance').value;

            if(daysWorkingWeek > daysWorking){		   
                text = "Must not exceed the number of company working days.";
                document.getElementById('daysWorkingWeekWarning').innerHTML = "<div class='help-inline'>"+text+"</div>";
            } else{
                document.getElementById('daysWorkingWeekWarning').innerHTML = "<div>"+text+"</div>";
            }

            if (isNaN(daysFullTimeAllowance) || daysFullTimeAllowance < 0 || daysFullTimeAllowance > 366) {
                text = "Must be a numerical value between 1 and 366.";
                document.getElementById('daysFullTimeAllowanceWarning').innerHTML = "<div class='help-inline'>"+text+"</div>";
            } else{
                document.getElementById('daysFullTimeAllowanceWarning').innerHTML =  "<div></div>";
            }

            let start_date = document.getElementById('start_date').value,
                end_date = document.getElementById('end_date').value,
                datepicker2 = document.getElementById('datepicker2').value,
                parts = start_date.split('/'),
                parts1 = end_date.split('/'),
                parts2 = datepicker2.split('/'),
                date1 = new Date(parts[2], parts[1]-1,parts[0]),
                date2 = new Date(parts1[2], parts1[1]-1,parts1[0]),
                datepicker22 = new Date(parts2[2], parts2[1]-1,parts2[0]),
                da = date1.getDate(),
                mo = date1.getMonth(),
                clast_day_year = date1.getFullYear(),
                clast_month = date1.getMonth(),
                last_day = new Date(clast_day_year+1,parts[1]-1,parts[0]),
		        first_day = new Date(clast_day_year,parts[1]-1,parts[0]);


            if(isNaN(datepicker22)){
                datepicker22 = last_day;
            }

            if(document.getElementById('Yrest_of_year').checked == false){
                datepicker22 = last_day;
            }
            
            if(date2 <= first_day){
                date2 = first_day;
            } else if(isNaN(date2)){
                date2 = first_day;
            }
            
            if (datepicker22 >= last_day){		
                datepicker22 = last_day;
            }

            
            if(date2 > last_day){
                document.getElementById('validate_date').innerHTML = "<div class='help-inline'>Start date should not be greater than the company annual leave end date.</div>";
            } else{
                document.getElementById('validate_date').innerHTML = "";
            }
            
            if(datepicker22 < date1){
                document.getElementById('valid_date').innerHTML = "<div class='help-inline'>End date should not be before the company leave start date.</div>";
            } else{
                document.getElementById('valid_date').innerHTML = "";
            }
            
            if(datepicker22 < date2){
                document.getElementById('valid_date').innerHTML = "<div class='help-inline'>End date should not be before the start date.</div>";
            } else{
                document.getElementById('valid_date').innerHTML = "";
            }


            // Calculations
            let Difference_In_Time;

            if(datepicker22 == last_day){
                Difference_In_Time = datepicker22.getTime() - date2.getTime() ; 
            } else{
                Difference_In_Time = datepicker22.getTime() + 86400000 - date2.getTime() ; 
            }

		    let full_days = date1.getFullYear() % 4 == 0 ? 1 : 0,
                last_day_annual= last_day.getFullYear() % 4 == 0 ? 1 : 0;

		    let Difference_In_Days = (Difference_In_Time / (1000 * 3600 * 24)),
                full_days_annual = last_day.getTime()- date1.getTime(),
                anu_difference_In_Days = full_days_annual / (1000 * 3600 * 24),
                company_last_day = last_day.getFullYear() % 4 == 0 ? 366 : 365,
		        company_first_day = first_day.getFullYear() % 4 == 0 ? 366 : 365;

            let days = daysWorkingWeek/daysWorking,
		        fulldays = Difference_In_Days/anu_difference_In_Days,
                total_working_days= daysFullTimeAllowance*(days)*(fulldays),
                last_value;
	
            if(document.getElementById('Ybank_holiday').checked == true){
                last_value = total_working_days - 8;
            } else{
                last_value = total_working_days;
            }

            let n = last_value.toString(),
                nn = n.indexOf(".");

            let rou, de_vale, res_text, total_val;

            if(nn != -1){
                rou = Math.ceil(last_value);
                de_vale = last_value.toFixed(2);
                res_text = "Prorated annual leave allowance rounded up from ";
                total_val = de_vale+" days";
            } else{
                res_text = "Prorated annual leave allowance.";
                rou = last_value;
                de_vale = last_value.toFixed(2);
                de_vale;
                total_val = '';
            }


            let fin_result, re_text;

            console.log(Difference_In_Time);
            if(rou < 0){
                fin_result = 0;
                document.getElementById("result_val").style.display = "none";
            } else{
                fin_result = rou;
            }

            if(document.getElementById('Yrest_of_year').checked == true){
                start_date = datepicker2;
                if(start_date == ''){
                    let month = ("0" + (last_day.getMonth() + 1)).slice(-2); 
                    let date = ("0" + last_day.getDate()).slice(-2); 
                    let y1 = last_day.getFullYear();
                    start_date = date+"/"+month+"/"+y1;
                }
                re_text="employee leaves on";
            }

            if(document.getElementById('Yrest_of_year').checked == false){
                let month = ("0" + (last_day.getMonth() + 1)).slice(-2); 
                let date = ("0" + last_day.getDate()).slice(-2); 
                let y1 = last_day.getFullYear();
                start_date = date+"/"+month+"/"+y1;
                re_text = "allowance renews on";
            }

            if (isNaN(daysWorking) || daysWorking < 1 || daysWorking > 7) {
                document.getElementById('annual-leave-total').innerHTML = "0";
                document.getElementById('annual-leave-renewal-date').innerHTML = re_text+" "+start_date;
            } else {
                document.getElementById('annual-leave-total').innerHTML = fin_result;
                document.getElementById('annual-leave-renewal-date').innerHTML = re_text+" "+start_date;
            }

        }
    }
}